"use strict";

exports.__esModule = true;
exports.getYValueForLinearData = exports.getYValueForBinnedData = void 0;
var _flatten2 = _interopRequireDefault(require("ramda/src/flatten"));
var _identity2 = _interopRequireDefault(require("ramda/src/identity"));
var _react = _interopRequireDefault(require("react"));
var _getXValue = require("./getXValue");
var _tooltipUtils = require("./Tooltips/tooltipUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/*
 * Used to add a row of TooltipYContent with max possible width,
 * so that the tooltip width does not increase or decrease based on diff. values
 */
var createMaxWidthTooltipYContent = function createMaxWidthTooltipYContent(listOfUnits) {
  if (listOfUnits.length === 0) {
    return;
  }
  var longestUnit = listOfUnits.reduce(function (a, b) {
    return a.length > b.length ? a : b;
  });
  /*
   * maxDigits: To create the tooltip, we consider 6 digit for max width.
   */

  var maxDigits = 999999;
  return /*#__PURE__*/_react["default"].createElement(TooltipYContent, {
    key: "max-width-tooltip-content",
    color: "",
    unit: "",
    value: 0,
    tickYFormat: function tickYFormat() {
      return maxDigits;
    },
    name: longestUnit,
    style: {
      height: "0px",
      overflow: "hidden",
      padding: 0
    }
  });
};
var TooltipYContent = function TooltipYContent(_ref) {
  var color = _ref.color,
    unit = _ref.unit,
    name = _ref.name,
    value = _ref.value,
    _ref$tickYFormat = _ref.tickYFormat,
    tickYFormat = _ref$tickYFormat === void 0 ? _identity2["default"] : _ref$tickYFormat,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var y = tickYFormat(unit, value);
  if (y === undefined) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: Object.assign({
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: "2px"
    }, style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "10px",
      height: "10px",
      backgroundColor: color,
      marginRight: "5px"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingLeft: "2px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "150px"
    }
  }, name || ""), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingLeft: "15px",
      marginLeft: "auto"
    }
  }, y));
};
var getYValueForBinnedData = exports.getYValueForBinnedData = function getYValueForBinnedData(_ref2) {
  var scale = _ref2.scale,
    left = _ref2.left,
    series = _ref2.series,
    tickYFormat = _ref2.tickYFormat;
  var timestamp = (0, _getXValue.getXAxisTimestampBandScale)(scale, left);
  var listOfUnits = [];
  var data = series[0].data.filter(function (_ref3) {
    var key = _ref3.key;
    return key === timestamp;
  }).map(function (_ref4) {
    var unit = _ref4.unit,
      value = _ref4.value,
      name = _ref4.name,
      color = _ref4.color,
      key = _ref4.key;
    var context = {
      key: key,
      unit: unit,
      value: value,
      name: name,
      color: color,
      tickYFormat: tickYFormat
    };
    listOfUnits.push(name);
    return /*#__PURE__*/_react["default"].createElement(TooltipYContent, _extends({
      key: key
    }, context));
  });
  var maxWidthTooltipYContent = createMaxWidthTooltipYContent(listOfUnits);
  maxWidthTooltipYContent && data.push(maxWidthTooltipYContent);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, data);
};
var getYValueForLinearData = exports.getYValueForLinearData = function getYValueForLinearData(_ref5) {
  var series = _ref5.series,
    scale = _ref5.scale,
    left = _ref5.left,
    tickYFormat = _ref5.tickYFormat;
  var timestampMillis = new Date((0, _tooltipUtils.getXAxisTimestampLinearScale)(scale, left)).valueOf();
  var closestX = (0, _getXValue.findClosestXValue)({
    series: series[0],
    timestamp: timestampMillis
  });
  var listOfUnits = [];
  var data = (0, _flatten2["default"])(series.map(function (x) {
    return x.data.map(function (val) {
      return Object.assign({}, val, {
        unit: x.unit
      });
    });
  })).filter(function (_ref6) {
    var key = _ref6.key;
    return Date.parse(key) === closestX;
  }).map(function (_ref7) {
    var unit = _ref7.unit,
      value = _ref7.value,
      color = _ref7.color,
      key = _ref7.key;
    var context = {
      key: key,
      unit: unit,
      value: value,
      color: color,
      tickYFormat: tickYFormat
    };
    listOfUnits.push(unit);
    return /*#__PURE__*/_react["default"].createElement(TooltipYContent, _extends({
      key: key
    }, context, {
      name: unit
    }));
  });
  var maxWidthTooltipYContent = createMaxWidthTooltipYContent(listOfUnits);
  maxWidthTooltipYContent && data.push(maxWidthTooltipYContent);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, data);
};